import { createSlice } from '@reduxjs/toolkit'

export const slice = createSlice({
  name: 'storedSettings',
  initialState: {
    settingsByName: {},
  },
  reducers: {
    setData: (state, action) => {
      state.settingsByName[action.payload.key] = action.payload.settings;
    }
  }
});


export const { setData } = slice.actions;
export const selectStoredSettings = (key, defaultValue) => state => state.storedSettings.settingsByName[key] ?? defaultValue;

export default slice.reducer;
